import { createImages } from "../../../../api/index.js";

export const uploadImages = async (images) => {

    const formData = new FormData();
    images.forEach((image, index) => {
        formData.append(`images`, image.file);
    });
    const files = images.map(i => i.file)
  
    try {
      const response = await createImages(formData);
      
      if (response.status !== 200) {
        throw new Error('Failed to upload images');
      }
  
      const imageUrls = await response.data;
      return imageUrls; // tableau d'URLs des images enregistrées
    } catch (error) {
      console.error('Error uploading images:', error);
      throw error;
    }
  };

  export const extractImagesFromContent = async (content, idArticle) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
  
    const imgElements = Array.from(doc.querySelectorAll('img')); // Convertir NodeList en Array pour utiliser map

    const imagePromises = imgElements.map(async (img, idx) => {
        let toBeReplaced = img.src;
        let file = null;
        let imageName = `${idArticle}_image${idx}.png`;

        if (img.src.startsWith('data:image/')) {
            // Convertir base64 en File asynchrone
            let base64 = img.src.split(',')[1];
            file = await resizeImageAndConvertToFile(base64, imageName);
            
            return {
                imageName,
                toBeReplaced,
                file,
            };
        }
    });

    // Attendre que toutes les promesses soient résolues
    const images = (await Promise.all(imagePromises)).filter(image => !!image); // Filtrer les undefined
    
    return images;
};
  
  // Fonction pour convertir une base64 en objet de type File
  const base64ToFile = (base64, fileName) => {
    const byteString = atob(base64);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
  
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    const blob = new Blob([ab], { type: 'image/png' });
    return new File([blob], fileName, { type: 'image/png' });
  };

  // Fonction pour redimensionner une image et ajuster sa qualité avant de la convertir en File
const resizeImageAndConvertToFile = async (base64, fileName, maxWidth = 1000, maxHeight = 1000, quality = 0.7) => {
  // Convertir base64 en Blob
  const blob = base64ToBlob(base64, 'image/png');
  const image = new Image();
  image.src = URL.createObjectURL(blob);

  // Attendre le chargement de l'image
  await new Promise(resolve => image.onload = resolve);

  // Créer un canvas pour redimensionner l'image
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // Calculer les nouvelles dimensions
  let width = image.width;
  let height = image.height;

  if (width > height) {
      if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
      }
  } else {
      if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
      }
  }

  canvas.width = width;
  canvas.height = height;

  // Dessiner l'image redimensionnée sur le canvas
  ctx.drawImage(image, 0, 0, width, height);

  // Convertir le canvas en Blob
  const resizedBlob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));

  // Convertir le Blob en File
  return new File([resizedBlob], fileName, { type: 'image/jpeg' });
};

// Fonction pour convertir une chaîne base64 en Blob
const base64ToBlob = (base64, contentType) => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};